module.exports = __webpack_public_path__ + "static/media/mentor-matcher-in-progress-no-bg.63ddd07c.svg";